import React, { useState, useEffect } from 'react';
import {
  ThemeProvider,
  CircularProgress,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyAccount as verifyAccountApi } from '../DataService';
import { theme } from '../styles/theme/theme';
import {
  AuthPageContainer,
  AuthFormCard,
  AuthPageTitle,
  AuthErrorMessage,
  AuthSuccessMessage,
  AuthGradientButton,
} from '../styles/components';

const VerifyAccount: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      const params = new URLSearchParams(location.search);
      const id = params.get('id');
      
      if (!id) {
        setError('Invalid verification link.');
        setLoading(false);
        return;
      }

      try {
        await verifyAccountApi({}, id);
        setSuccess(true);
      } catch (err: any) {
        setError(err?.message || 'Account verification failed.');
      }
      setLoading(false);
    };

    verifyToken();
  }, [location.search]);

  return (
    <ThemeProvider theme={theme}>
      <AuthPageContainer>
        <AuthFormCard elevation={6}>
          <AuthPageTitle variant="h5">
            Account Verification
          </AuthPageTitle>

          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
              <CircularProgress />
            </div>
          ) : success ? (
            <>
              <AuthSuccessMessage>
                Your account has been verified successfully.
              </AuthSuccessMessage>

              <AuthGradientButton
                fullWidth
                variant="contained"
                onClick={() => navigate('/sign-in')}
              >
                Go to Sign In
              </AuthGradientButton>
            </>
          ) : (
            <>
              <AuthErrorMessage>
                {error}
              </AuthErrorMessage>

              <AuthGradientButton
                fullWidth
                variant="contained"
                onClick={() => navigate('/sign-in')}
              >
                Return to Sign In
              </AuthGradientButton>
            </>
          )}
        </AuthFormCard>
      </AuthPageContainer>
    </ThemeProvider>
  );
};

export default VerifyAccount; 